export const Paths = {
  search: { url: "/" },
  detailsPage: { url: "/items/:itemId+" },
  checkout: { url: "/checkout" },
  confirmation: { url: "/confirmation" },
  orders: { url: "/orders" },
  campaigns: { url: "/campaigns" },
  sessionExpired: { url: "/session-expired" },
  notFound: { url: "*" },
} as const;
